import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer, Image } from '@mafc/trolly';
import RequestUpdated from 'assets/request-updated.png';

import * as S from './DriverTipDrawer.style';

const DriverTipDrawer: React.FC<{
  isOpen: boolean;
  closeDrawer: () => void;
}> = ({ isOpen, closeDrawer }) => {
  const { t } = useTranslation();
  useEffect(() => {
    const timeoutId = setTimeout(() => closeDrawer(), 5000);
    return () => clearTimeout(timeoutId);
  }, [closeDrawer]);

  return (
    <Drawer
      anchor={['bottom', null, 'right']}
      isOpen={isOpen}
      onClose={closeDrawer}
      title={<S.Title>{t('driverTips.heading')}</S.Title>}
      variant="float"
      containerStyles={{
        borderTopLeftRadius: [4, null, null, 0],
        borderTopRightRadius: [4, null, null, 0],
      }}
      isTitleBorder={false}
      contentStyles={{ pt: 1, borderRadius: '20px' }}
      width={[null, null, '480px']}
      data-testid="driver-tip-drawer"
    >
      <S.DriverTipDrawer>
        <Image url={RequestUpdated} name="request-updated" width="auto" />
        <S.ComingSoon>{t('driverTips.comingSoon')}</S.ComingSoon>
      </S.DriverTipDrawer>

      <S.GoItButton
        onClick={closeDrawer}
        variant="custom"
        preventTextTransform
        data-testid="close-tip-btn"
      >
        {t('deliverySlot.okGotIt')}
      </S.GoItButton>
    </Drawer>
  );
};

export default DriverTipDrawer;
